module.exports = __webpack_public_path__ + "img/heart_15.4f7ebe37.png";